<template>
  <div class="line-items">
    <Header :currency-id="invoiceCurrency" v-on="$listeners" />
    <List @getPaymentPreview="$emit('getPaymentPreview')" />
    <Footer />
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import Header from "../LineItems/Header.vue";
import List from "../LineItems/List.vue";
import Footer from "../LineItems/Footer.vue";

export default {
  components: {
    Header,
    List,
    Footer
  },

  props: {
    currencies: { type: Array },
    taxes: { type: Array },
    invoiceCurrency: { type: Number }
  },

  created () {
    this.updateCurrencies(this.currencies);
  },

  methods: {
    ...mapMutations("instruments", [
      "updateCurrencies"
    ])
  }
};
</script>
